import { Box, BoxProps, Paper } from "@mui/material";
import DataTableContent from "./data-table-content";
import DataTablePagination from "./data-table-pagination";
import DataTableEntryOption from "./data-table-entry-option";

interface DataTableProps extends BoxProps {

}

export default function DataTable({
    children,
    ...props
}:DataTableProps){
    return <Paper
        variant="outlined" component={Box}
        display={"flex"} flexDirection={"column"}
        overflow={"clip"} position={"relative"}
        elevation={0} {...props}
    >
        {children}
    </Paper>
}


DataTable.Content = DataTableContent;
DataTable.Pagination = DataTablePagination;
DataTable.EntryOption = DataTableEntryOption;